@for (toast of toastService.toasts; track toast) {
  <ngb-toast [class]="toast.classname" [autohide]="true" [delay]="toast.delay || 5000" (hide)="toastService.remove(toast)">
    <ng-template ngbToastHeader>
      @switch (toast.mode) {
        @case ('info') {
          <div><fa-icon [icon]="['fas', 'info-circle']" class="text-info"></fa-icon> Informatie</div>
        }
        @case ('success') {
          <div><fa-icon [icon]="['fas', 'check-circle']" class="text-success"></fa-icon> Succes!</div>
        }
        @case ('error') {
          <div><fa-icon [icon]="['fas', 'exclamation-circle']" class="text-danger"></fa-icon> Foutmelding!</div>
        }
        @default {
          <div><fa-icon [icon]="['fas', 'exclamation-circle']" class="text-danger"></fa-icon> Bericht</div>
        }
      }
    </ng-template>
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
  </ngb-toast>
}
